import { ResolveFn } from '@angular/router';
import { AIRPORT_DATA } from './airport-loaders';
import { AirportDetail } from './airport-types';

// A resolver, not ngOnInit: the router waits for it, so server rendering always has the data.
// The route's canMatch has already checked the airport exists. The index is imported on demand
// so it stays out of the main bundle (this resolver is referenced from the routes).
export const airportResolver: ResolveFn<AirportDetail | undefined> = async route => {
  const { findAirport } = await import('./airport-copy');
  const entry = findAirport(route.paramMap.get('airport'));
  if (!entry) return undefined;
  const list = await AIRPORT_DATA[entry.region]();
  return list.find(a => a.iata === entry.iata);
};
